import { render, staticRenderFns } from "./Leftbar.vue?vue&type=template&id=f9974506&"
import script from "./Leftbar.vue?vue&type=script&lang=js&"
export * from "./Leftbar.vue?vue&type=script&lang=js&"
import style0 from "./Leftbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports